var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DescriptionSection',[_c('DescriptionItem',{attrs:{"title":"Dokumenty","value":_vm.service.attachments.length.toString()}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }